import { takeLatest, takeLeading, all, call, put, select } from 'redux-saga/effects';
import {
  GET_MY_REFERRED_LIST,
  GET_NOTIFICATIONS_LIST,
  GET_NOTIFICATION_DETAIL,
  GET_TOP_REFERRAL_LIST,
  UPLOAD_PAN_IMAGE,
  UPLOAD_BANK_IMAGE,
  setBanners,
  GET_BANNERS
} from '../actions/more-actions-types';
import httpClient from './http-client';

function* getMyReferredList({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('user_id', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'main-admin/commisionlist'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* getTopReferralList({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'api/referrallist'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* getNotificationsList({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('user_id', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/leauges/androidusernotifications'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* getBanners() {
  const payload = {
    method: 'GET',
    url: 'api/allBanners'
  };

  const { result, error } = yield call(httpClient, payload, false);
  if (!error) {
    yield put(setBanners(result));
  }
}

function* getNotificationDetail({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('user_id', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/leauges/seennotifications'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* uploadPANImage({ payload: { data, callback } }) {
  const userId = yield select(({ user: { userId } }) => userId);
  const formData = new FormData();
  const { file, name } = data;
  formData.append('Pan', file, name);
  const payload = {
    data: formData,
    method: 'POST',
    url: `users/${userId}/uploads`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* uploadBankImage({ payload: { data, callback } }) {
  const userId = yield select(({ user: { userId } }) => userId);
  const formData = new FormData();
  const { file, name } = data;
  formData.append('BankAccount', file, name);
  const payload = {
    data: formData,
    method: 'POST',
    url: `users/${userId}/uploads`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* more() {
  yield all([
    yield takeLatest(GET_MY_REFERRED_LIST, getMyReferredList),
    yield takeLatest(GET_TOP_REFERRAL_LIST, getTopReferralList),
    yield takeLatest(GET_NOTIFICATIONS_LIST, getNotificationsList),
    yield takeLatest(GET_NOTIFICATION_DETAIL, getNotificationDetail),
    yield takeLeading(UPLOAD_PAN_IMAGE, uploadPANImage),
    yield takeLeading(UPLOAD_BANK_IMAGE, uploadBankImage),
    yield takeLatest(GET_BANNERS, getBanners)
  ]);
}

export default more;
